import { useGetUser } from 'api/account';

export const useGetCurrentOrganisationId = () => {
  const { data } = useGetUser();

  return data!.lastBoard.organisationId;
};
